export const COMMON_EXCLUDED_FOR_MANAGER = ['/debt', '/client_events', '/store/orders', '/notification_templates', '/notifications/global'];
export const DEVELOPMENT_EXCLUDED_FOR_MANAGER = ['/tender/calculation', '/failed_billings', '/downgraded_orders'];

export const MANAGER_TYPES = {
    SELL_MANAGER: 'SELL_MANAGER',
    CLIENT_MANAGER: 'CLIENT_MANAGER',
    DEVELOPMENT_MANAGER: 'DEVELOPMENT_MANAGER',
}